function googleTranslateElementInit() {
    new google.translate.TranslateElement({
        pageLanguage: 'sv',
        includedLanguages: 'sv,en,da,no,fi,fr,de,es,nl,ar'
    }, 'google_translate_element');
}

jQuery(document).ready(function ($) {
    'use strict';


    // hoisted ---------------------------
    function isTranslated() { // true if the text has been translated
        var currentPH = $($('#placeholders > div')[0]).text();
        return !(originalPH == currentPH);
    }

    function updatePlaceholders() {
        $('#placeholders > div').each(function (i, div) {
            placeholders[i].placeholder = $(div).text();
        });
    }

    // Find all placeholders
    var placeholders = document.querySelectorAll('input[placeholder]');

    if (placeholders.length) {
        // convert to array
        placeholders = Array.prototype.slice.call(placeholders);

        // copy placeholder text to a hidden div
        var div = $('<div id="placeholders" style="display:none;"></div>');

        placeholders.forEach(function (input) {
            var text = input.placeholder;
            div.append('<div>' + text + '</div>');
        });

        $('body').append(div);

        // save the first placeholder in a closure
        var originalPH = placeholders[0].placeholder;

        // check for changes and update as needed
        setInterval(function () {
            if (isTranslated()) {
                updatePlaceholders();
                originalPH = placeholders[0].placeholder;
            }
        }, 500);
    }
    // RESTYLE THE DROPDOWN MENU

    (function() {
        'use strict';

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if(mutation.type === 'attributes' && mutation.attributeName === 'lang') {
                    const event = new Event('languagechanged');
                    document.body.dispatchEvent(event);
                }
            });
        });

        observer.observe(document.querySelector('html'), { attributes: true});
    }());
});
